/**
 * @generated SignedSource<<2f0ec6d00be22bdbece9eefe4449d122>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation$variables = {
  announcementId: string;
  linkId: string;
};
export type CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation$data = {
  readonly removeLinksFromAnnouncement: {
    readonly announcementUpdated: {
      readonly id: string;
    };
  } | null;
};
export type CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation = {
  response: CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation$data;
  variables: CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "announcementId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "linkId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "announcementId",
            "variableName": "announcementId"
          },
          {
            "items": [
              {
                "kind": "Variable",
                "name": "linkIds.0",
                "variableName": "linkId"
              }
            ],
            "kind": "ListValue",
            "name": "linkIds"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AnnouncementsRemoveLinksMutationPayload",
    "kind": "LinkedField",
    "name": "removeLinksFromAnnouncement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Announcement",
        "kind": "LinkedField",
        "name": "announcementUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3800482c3c137e98f34659947bdb18d",
    "id": null,
    "metadata": {},
    "name": "CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation",
    "operationKind": "mutation",
    "text": "mutation CreateAnnouncementOverlay_removeLinksFromAnnouncement_Mutation(\n  $announcementId: ID!\n  $linkId: ID!\n) {\n  removeLinksFromAnnouncement(input: {announcementId: $announcementId, linkIds: [$linkId]}) {\n    announcementUpdated {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6a947824ec14cb4add117b312c00520";

export default node;
